import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo.png";
import "./Navbar.css";

const LINKS = [
  { label: "Home",     id: "home"     },
  { label: "About",    id: "about"    },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Gallery",  id: "gallery"  },
  { label: "Team",     id: "team"     },
  { label: "Contact",  id: "contact"  },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-inner">
        <Link
          to="/"
          className="nav-logo-link"
          onClick={() => document.getElementById("home")?.scrollIntoView({ behavior: "smooth" })}
        >
          <img src={logo} alt="Everlink" className="nav-logo-img" />
          <div className="nav-brand">
            Everlink Telesat
            <span>Network Limited</span>
          </div>
        </Link>

        <ul className="nav-links">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button onClick={() => scrollTo(l.id)}>{l.label}</button>
            </li>
          ))}
        </ul>

        <button className="btn btn-primary nav-cta" onClick={() => scrollTo("contact")}>
          Get In Touch
        </button>

        <button className="nav-hamburger" onClick={() => setOpen((o) => !o)} aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="nav-drawer">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)}>{l.label}</button>
          ))}
          <button className="btn btn-primary" onClick={() => scrollTo("contact")}>Get In Touch</button>
        </div>
      )}
    </nav>
  );
}
